import { render, staticRenderFns } from "./_setting.vue?vue&type=template&id=4d9c7768&lang=pug&"
import script from "./_setting.vue?vue&type=script&lang=js&"
export * from "./_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports